var lg_AKB32273504 = {
    name: "AKB32273504",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [67,0,4,132,2,202,1,128,2,65,6,229,17,69,17,129,2,0,0,58,223,91,213,123,234,136],
        },
        {
            function: "KEY_EJECT",
            name: "KEY_EJECT",
            icon: "KEY_EJECT",
            command: [67,0,4,128,2,202,1,129,2,67,6,228,17,70,17,144,2,0,0,58,223,91,218,235,117,136],
        },
        {
            function: "KEY_BAND",
            name: "KEY_BAND",
            icon: "KEY_BAND",
            command: [67,0,4,129,2,200,1,135,2,66,6,219,17,74,17,122,2,0,0,58,223,91,186,221,118,136],
        },
        {
            // function: "KEY_DVD",
            function : "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [67,0,4,130,2,205,1,128,2,64,6,246,17,67,17,124,2,0,0,58,223,91,175,250,170,136],
        },
        {
            function: "KEY_AUX",
            name: "KEY_AUX",
            icon: "KEY_AUX",
            command: [67,0,4,132,2,196,1,133,2,67,6,222,17,48,17,164,2,0,0,58,223,91,219,214,213,136],
        },
        {
            function: "KEY_USB",
            name: "KEY_USB",
            icon: "KEY_USB",
            command: [73,0,5,123,2,203,1,130,2,71,6,218,17,69,17,118,2,213,182,127,2,0,0,58,223,91,173,95,122,137,66],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [73,0,5,132,2,199,1,131,2,65,6,239,17,69,17,123,2,161,182,122,2,0,0,58,223,91,191,117,86,137,66],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [73,0,5,124,2,204,1,130,2,69,6,222,17,65,17,120,2,198,182,132,2,0,0,58,223,91,223,109,86,137,66],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [73,0,5,132,2,204,1,128,2,66,6,222,17,52,17,124,2,187,182,133,2,0,0,58,223,91,175,189,86,137,66],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [73,0,5,133,2,206,1,135,2,52,6,222,17,64,17,138,2,200,182,134,2,0,0,58,223,91,239,107,86,137,66],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [67,0,4,125,2,205,1,130,2,71,6,224,17,64,17,121,2,0,0,58,223,91,183,187,86,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [73,0,5,124,2,206,1,129,2,71,6,255,17,55,17,115,2,172,182,136,2,0,0,58,223,91,215,183,86,137,66],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [73,0,5,128,2,206,1,127,2,70,6,233,17,67,17,118,2,182,182,118,2,0,0,58,223,91,171,223,86,137,66],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [73,0,5,127,2,204,1,129,2,70,6,217,17,52,17,118,2,213,182,133,2,0,0,58,223,91,247,106,214,137,66],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [73,0,5,127,2,201,1,134,2,70,6,224,17,63,17,118,2,202,182,131,2,0,0,58,223,91,187,186,214,137,66],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [67,0,4,125,2,206,1,129,2,70,6,228,17,73,17,130,2,0,0,58,223,91,173,222,214,136],
        },
        {
            function: "KEY_VSM",
            name: "KEY_VSM",
            icon: "KEY_VSM",
            command: [67,0,4,133,2,206,1,135,2,51,6,226,17,75,17,139,2,0,0,58,223,91,170,235,235,136],
        },
        {
            function: "KEY_XTSPRO",
            name: "KEY_XTSPRO",
            icon: "KEY_XTSPRO",
            command: [73,0,5,133,2,200,1,141,2,48,6,225,17,65,17,166,2,208,182,137,2,0,0,58,223,91,170,173,253,137,66],
        },
        {
            function: "KEY_MARKER",
            name: "KEY_MARKER",
            icon: "KEY_MARKER",
            command: [67,0,4,129,2,205,1,128,2,63,6,218,17,71,17,138,2,0,0,58,223,91,237,106,221,136],
        },
        {
            function: "KEY_SEARCH",
            name: "KEY_SEARCH",
            icon: "KEY_SEARCH",
            command: [67,0,4,136,2,209,1,134,2,46,6,224,17,36,17,133,2,0,0,58,223,91,174,183,93,136],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [73,0,5,126,2,206,1,126,2,70,6,222,17,68,17,142,2,212,182,129,2,0,0,58,223,91,253,170,173,137,66],
        },
        {
            function: "KEY_SOUND",
            name: "KEY_SOUND",
            icon: "KEY_SOUND",
            command: [73,0,5,136,2,204,1,138,2,49,6,222,17,66,17,127,2,224,182,133,2,0,0,58,223,91,190,218,173,137,66],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [73,0,5,140,2,189,1,143,2,58,6,249,17,55,17,148,2,222,182,138,2,0,0,58,223,91,173,183,109,137,66],
        },
        {
            // function: "KEY_RETURN",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [73,0,5,135,2,204,1,135,2,50,6,222,17,66,17,134,2,226,182,135,2,0,0,58,223,91,222,214,173,137,66],
        },
        {
            function: "KEY_SETUP",
            name: "KEY_SETUP",
            icon: "KEY_SETUP",
            command: [73,0,5,129,2,198,1,136,2,67,6,228,17,68,17,134,2,221,182,128,2,0,0,58,223,91,183,109,173,137,66],
        },
        {
            function: "KEY_DISPLAY",
            name: "KEY_DISPLAY",
            icon: "KEY_DISPLAY",
            command: [73,0,5,129,2,198,1,134,2,69,6,225,17,69,17,142,2,216,182,123,2,0,0,58,223,91,175,110,173,137,66],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [67,0,4,123,2,204,1,131,2,72,6,229,17,72,17,140,2,0,0,58,223,91,238,213,173,136],
        },
        {
            function: "KEY_TITLE",
            name: "KEY_TITLE",
            icon: "KEY_TITLE",
            command: [67,0,4,126,2,203,1,130,2,69,6,244,17,67,17,137,2,0,0,58,223,91,170,219,237,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [67,0,4,124,2,206,1,128,2,70,6,229,17,64,17,141,2,0,0,58,223,91,171,183,173,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [67,0,4,136,2,205,1,134,2,50,6,222,17,63,17,133,2,0,0,58,223,91,246,213,109,136],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [67,0,4,136,2,202,1,135,2,54,6,220,17,66,17,133,2,0,0,58,223,91,215,107,173,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [67,0,4,124,2,201,1,134,2,71,6,230,17,72,17,134,2,0,0,58,223,91,187,109,109,136],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [73,0,5,121,2,208,1,129,2,72,6,222,17,74,17,119,2,215,182,121,2,0,0,58,223,91,174,222,182,137,66],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [67,0,4,126,2,204,1,132,2,69,6,242,17,76,17,120,2,0,0,58,223,91,221,182,182,136],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [73,0,5,140,2,196,1,137,2,56,6,231,17,63,17,134,2,200,182,130,2,0,0,58,223,91,239,214,170,137,66],
        },
        {
            function: "KEY_PREVIOUS",
            name: "KEY_PREVIOUS",
            icon: "KEY_PREVIOUS",
            command: [73,0,5,133,2,201,1,132,2,61,6,246,17,70,17,135,2,161,182,134,2,0,0,58,223,91,215,238,170,137,66],
        },
        {
            function: "KEY_NEXT",
            name: "KEY_NEXT",
            icon: "KEY_NEXT",
            command: [73,0,5,128,2,206,1,127,2,69,6,221,17,74,17,121,2,207,182,123,2,0,0,58,223,91,171,254,170,137,66],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [67,0,4,128,2,205,1,127,2,71,6,218,17,66,17,119,2,0,0,58,223,91,170,239,214,136],
        },
        {
            function: "KEY_REPEAT",
            name: "KEY_REPEAT",
            icon: "KEY_REPEAT",
            command: [73,0,5,128,2,203,1,132,2,66,6,224,17,58,17,124,2,211,182,130,2,0,0,58,223,91,213,219,214,137,66],
        },
        {
            function: "KEY_REPEATAB",
            name: "KEY_REPEATAB",
            icon: "KEY_REPEATAB",
            command: [73,0,5,127,2,198,1,140,2,64,6,223,17,59,17,135,2,204,182,122,2,0,0,58,223,91,181,182,237,137,66],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [73,0,5,134,2,199,1,134,2,64,6,227,17,66,17,127,2,201,182,121,2,0,0,58,223,91,183,246,170,137,66],
        },
        {
            function: "KEY_PROG_MEMO",
            name: "KEY_PROG_MEMO",
            icon: "KEY_PROG_MEMO",
            command: [73,0,5,127,2,204,1,130,2,70,6,230,17,64,17,119,2,207,182,119,2,0,0,58,223,91,181,221,214,137,66],
        },
        {
            function: "KEY_CLEAR",
            name: "KEY_CLEAR",
            icon: "KEY_CLEAR",
            command: [73,0,5,131,2,201,1,129,2,66,6,231,17,55,17,135,2,185,182,131,2,0,0,58,223,91,250,213,93,137,66],
        },
        {
            function: "KEY_ZOOM",
            name: "KEY_ZOOM",
            icon: "KEY_ZOOM",
            command: [73,0,5,126,2,203,1,130,2,70,6,228,17,69,17,136,2,215,182,122,2,0,0,58,223,91,213,181,237,137,66],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [67,0,4,129,2,203,1,133,2,66,6,219,17,74,17,125,2,0,0,58,223,91,171,127,106,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [73,0,5,131,2,201,1,133,2,64,6,227,17,61,17,125,2,198,182,127,2,0,0,58,223,91,214,247,106,137,66],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [73,0,5,130,2,205,1,126,2,69,6,233,17,72,17,121,2,213,182,131,2,0,0,58,223,91,170,191,234,137,66],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [67,0,4,129,2,203,1,125,2,70,6,216,17,63,17,163,2,0,0,58,223,91,223,86,171,136],
        },
        {
            function: "KEY_DIMMER",
            name: "KEY_DIMMER",
            icon: "KEY_DIMMER",
            command: [73,0,5,133,2,204,1,135,2,55,6,225,17,66,17,148,2,217,182,132,2,0,0,58,223,91,213,109,246,137,66],
        },
        {
            function: "KEY_ECHOVOLUMEUP",
            name: "KEY_ECHOVOLUMEUP",
            icon: "KEY_ECHOVOLUMEUP",
            command: [73,0,5,129,2,199,1,130,2,70,6,238,17,75,17,139,2,186,182,121,2,0,0,58,223,91,181,91,125,137,66],
        },
        {
            function: "KEY_ECHOVOLUMEDOWN",
            name: "KEY_ECHOVOLUMEDOWN",
            icon: "KEY_ECHOVOLUMEDOWN",
            command: [73,0,5,130,2,203,1,128,2,68,6,233,17,71,17,135,2,220,182,130,2,0,0,58,223,91,213,90,253,137,66],
        },
        {
            function: "KEY_MICVOLUMEUP",
            name: "KEY_MICVOLUMEUP",
            icon: "KEY_MICVOLUMEUP",
            command: [67,0,4,131,2,198,1,133,2,65,6,233,17,73,17,139,2,0,0,58,223,91,173,91,189,136],
        },
        {
            function: "KEY_MICVOLUMEDOWN",
            name: "KEY_MICVOLUMEDOWN",
            icon: "KEY_MICVOLUMEDOWN",
            command: [67,0,4,133,2,200,1,131,2,64,6,245,17,71,17,145,2,0,0,58,223,91,234,181,125,136],
        },
        {
            function: "KEY_TV_POWER",
            name: "KEY_TV_POWER",
            icon: "KEY_TV_POWER",
            command: [23,0,4,167,3,233,2,242,6,231,2,174,3,76,6,175,3,0,0,223,154,32],
        },
        {
            function: "KEY_TV_VOLUMEUP",
            name: "KEY_TV_VOLUMEUP",
            icon: "KEY_TV_VOLUMEUP",
            command: [23,0,4,168,3,234,2,234,6,236,2,170,3,74,6,175,3,0,0,223,46,32],
        },
        {
            function: "KEY_TV_VOLUMEDOWN",
            name: "KEY_TV_VOLUMEDOWN",
            icon: "KEY_TV_VOLUMEDOWN",
            command: [23,0,4,170,3,232,2,237,6,235,2,174,3,75,6,152,3,0,0,191,44,136],
        },
        {
            // function: "KEY_TV_CHANNELUP",
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [23,0,4,169,3,231,2,236,6,238,2,172,3,76,6,170,3,0,0,190,94,32],
        },
        {
            // function: "KEY_TV_CHANNELDOWN",
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [22,0,4,228,2,172,3,234,2,246,6,75,6,229,6,75,6,152,3,126,120,128],
        },
        {
            function: "KEY_TV_MUTE",
            name: "KEY_TV_MUTE",
            icon: "KEY_TV_MUTE",
            command: [22,0,3,228,2,172,3,231,2,250,6,75,6,152,3,191,148,128],
        },
        {
            function: "KEY_TV_INPUT",
            name: "KEY_TV_INPUT",
            icon: "KEY_TV_INPUT",
            command: [23,0,4,174,3,229,2,249,6,215,2,169,3,76,6,206,3,0,0,222,118,32],
        },
    ]
}
export default lg_AKB32273504